export const EMAIL_PATTERN = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

type ValidationRules = {
  pattern: {
    value: RegExp;
    message: string;
  };
};

type GetEmailValidationRulesOptions = {
  label?: string;
};

export function getEmailValidationRules(options: GetEmailValidationRulesOptions = {}): ValidationRules {
  const { label = "email" } = options;

  return {
    pattern: {
      value: EMAIL_PATTERN,
      message: `Enter a valid ${label.toLowerCase()}`,
    },
  };
}

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email?.trim().toLowerCase());
}
